// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e0f6a32","381":"a8831447","453":"89441e4a","455":"a7de07fd","977":"e5891e5f"}[chunkId] + ".chunk.js";
};